import React from 'react';
import './Witstorms.css';

const logoSrc = '/logo.jpg';
// PDF is served from the same public root as the logo.
const RESEARCH_PAPER_URL = '/context.pdf';

export default function ResearchPage({ onBack }) {
  const handleOpenPaper = () => {
    window.open(RESEARCH_PAPER_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="font-sans text-gray-100 bg-animated min-h-screen">
      <header className="header">
        <nav className="nav">
          <div className="logo-container">
            <img src={logoSrc} alt="Witstorms Intelligence Logo" className="logo-image" />
            <span className="logo-text">Witstorms Intelligence</span>
          </div>
          <div className="nav-links">
            <button
              type="button"
              className="nav-link nav-link-button"
              onClick={() => onBack && onBack()}
            >
              Back to Home
            </button>
          </div>
        </nav>
      </header>

      <main className="research-page">
        <div className="research-container">
          <div className="section-header">
            <h1 className="section-title">Research</h1>
            <p className="section-subtitle">
              Causal and semantic coherence in small context size fragmented retrieval.
            </p>
          </div>

          <div className="research-list">
            <button
              type="button"
              className="research-item"
              onClick={handleOpenPaper}
            >
              <h2 className="research-title">
              With small context size, large language models maintain causal and semantic coherence under moderate context fragmentation in Retrieval-Augmented Generation systems.
              </h2>
              <p className="research-meta">
                PDF • Evidence-based AI-powered clinical decision support system
              </p>
            </button>
          </div>

          <div style={{ marginTop: '2rem', height: '70vh' }}>
            <iframe
              title="Witstorms Research Paper"
              src={RESEARCH_PAPER_URL}
              style={{
                width: '100%',
                height: '100%',
                border: '1px solid rgba(148,163,184,0.4)',
                borderRadius: '12px',
              }}
            />
          </div>
        </div>
      </main>
    </div>
  );
}

